<template>
  <div class="content-agreement clearFix">
    <div>
      <div class="model">
        <h3 style="text-align: center;">灵猴软件许可及服务协议</h3>
      </div>
      <div class="model">
        <p class="p1">首部及导言</p>
        <p class="p2 in">欢迎您使用北京小黄人科技有限公司灵猴服务！</p>
        <p class="p2 in">为使用北京小黄人科技有限公司灵猴服务（以下简称“本服务”），你应当阅读并遵守《北京小黄人科技有限公司灵猴软件许可及服务协议》（以下简称“本协议”）。请你务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。限制、免责条款可能以加粗形式提示你注意。</p>
        <p class="p2 in">如果您因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人（以下简称"监护人"）的陪同下阅读和判断是否同意本协议，并特别注意未成年人使用条款。</p>
        <p class="p2 in">如果您是中国大陆地区以外的用户，您订立或履行本协议还需要同时遵守您所属和/或所处国家或地区的法律。</p>
        <p class="p2 in">除非您已充分阅读、完全理解并接受本协议所有条款，否则您无权使用小黄人科技服务。您点击“同意”或“下一步”，或您使用小黄人科技服务，或者以其他任何明示或者默示方式表示接受本协议的，均视为您已阅读并同意签署本协议。本协议即在您与小黄人科技之间产生法律效力，成为对双方均具有约束力的法律文件。</p>
        <p class="p2" style="text-align: right;">欢迎您使用北京小黄人科技有限公司的服务！</p>
      </div>
      <div class="model">
        <p class="p1">一 协议的范围</p>
        <p class="p2">1.1协议适用主体范围</p>
        <p class="p2 in">本协议是您与小黄人科技之间关于您使用小黄人科技相关服务所订立的协议。</p>
        <p class="p2">1.2协议关系及冲突条款</p>
        <p class="p2 in">本协议内容同时包括小黄人科技可能不断发布的关于本服务的相关协议、业务规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，你同样应当遵守。</p>
      </div>
      <div class="model">
        <p class="p1">二 关于本服务</p>
        <p class="p2">2.1本服务的内容</p>
        <p class="p2 in">本服务内容是指小黄人科技向用户提供专注于新媒体用户增长、营销、变现、数据分析的软件工具平台（以下简称“灵猴”），用户提供包括但不限于基于微信的订阅号&服务号管理、消息通信工具、数据分析平台、与其他软件或硬件信息互通等功能或内容的软件许可及服务（以下简称“本服务”）。</p>
        <p class="p2">2.2本服务的形式</p>
        <p class="p2" style="margin-left: 32px;">2.2.1您使用本服务需要在线注册小黄人科技灵猴平台，对于这些软件，小黄人科技给予您一项个人的、不可转让及非排他性的许可。您仅可为访问或使用本服务的目的而使用这些软件及服务。</p>
        <p class="p2" style="margin-left: 32px;">2.2.2本服务中小黄人科技灵猴平台可能提供包括但不限于市面上的主流社交媒体，浏览器（微信、微博、谷歌浏览器）和手机终端，非主流社交媒体，浏览器（微信、微博、谷歌浏览器）和手机终端。</p>
        <p class="p2">2.3 本服务许可的范围</p>
        <p class="p2" style="margin-left: 32px;">2.3.1小黄人科技给予您一项个人的、不可转让及非排他性的许可，以使用本软件。您可以为非商业目的在单一台终端设备上安装、使用、显示、运行本软件。</p>
        <p class="p2" style="margin-left: 32px;">2.3.2您可以为使用本软件及服务的目的复制本软件的一个副本，仅用作备份。备份副本必须包含原软件中含有的所有著作权信息。</p>
        <p class="p2" style="margin-left: 32px;">2.3.3本条及本协议其他条款未明示授权的其他一切权利仍由小黄人科技保留，您在行使这些权利时须另外取得小黄人科技的书面许可。小黄人科技如果未行使前述任何权利，并不构成对该权利的放弃。</p>
      </div>
      <div class="model">
        <p class="p1">三 软件的获取</p>
        <p class="p2">3.1您可以直接从小黄人科技的网站上获取本软件，也可以从得到小黄人科技授权的第三方获取。</p>
        <p class="p2">3.2如果您从未经小黄人科技授权的第三方获取本软件或与本软件名称相同的安装程序，小黄人科技无法保证该软件能够正常使用，并对因此给您将造成的损失不予负责。</p>
      </div>
      <div class="model">
        <p class="p1">四 软件的更新</p>
        <p class="p2">4.1为了改善用户体验、完善服务内容，小黄人科技将不断努力开发新的服务，并为您不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。</p>
        <p class="p2">4.2为了保证本软件及服务的安全性和功能的一致性，小黄人科技有权不经向您特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。</p>
        <p class="p2">4.3本软件新版本发布后，旧版本的软件可能无法使用。小黄人科技不保证旧版本软件继续可用及相应的客户服务，请您随时核对并更新最新版本。</p>
      </div>
      <div class="model">
        <p class="p1">五 用户个人信息保护</p>
        <p class="p2">5.1保护用户个人信息是小黄人科技的一项基本原则，小黄人科技将会采取合理的措施保护用户的个人信息。除法律法规规定的情形外，未经用户许可小黄人科技不会向第三方公开、透露用户个人信息。小黄人科技对相关信息采用专业加密存储与传输方式，保障用户个人信息的安全。</p>
        <p class="p2">5.2您在注册账号或使用本服务的过程中，需要提供一些必要的信息，例如：为向您提供账号注册服务或进行用户身份识别，需要您填写手机号码；需要您授权您的微信或微博等第三方账号的ID及头像和昵称，您需要填写、提交及/或以其他任何方式提供您的个人信息，包括但不限于您的姓名、性别、出生年月日、身份证号码、电话号码、电子邮箱、收货地址及相关附加信息（如您地址中的所在省份和城市、邮政编码等）、银行账户或其他支付工具的账户信息等。若国家法律法规或政策有特殊规定的，您需要提供真实的身份信息。若您提供的信息不完整，则无法使用本服务或在使用过程中受到限制。</p>
        <p class="p2">5.3一般情况下，您可随时浏览、修改自己提交的信息，但出于安全性和身份识别（如号码申诉服务）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。</p>
        <p class="p2">5.4小黄人科技将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。</p>
        <p class="p2">5.5未经您的同意，小黄人科技不会向小黄人科技以外的任何公司、组织和个人披露您的个人信息，但法律法规另有规定的除外。</p>
        <p class="p2">5.6小黄人科技非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用小黄人科技的服务前，应事先取得您家长或法定监护人的书面同意。</p>
      </div>
      <div class="model">
        <p class="p1">六 主权利义务条款</p>
        <p class="p2">6.1 账号使用规范</p>
        <p class="p2" style="margin-left: 32px">6.1.1您在使用本服务前需要注册一个灵猴账号。灵猴账号可通过手机号码进行注册,并可在注册成功后绑定订阅号、服务号、邮箱。如您使用邮箱账号进行绑定，请你使用未与灵猴平台账号绑定的邮箱账号。小黄人科技有权根据用户需求或产品需要对账号注册和绑定的方式进行变更，关于您使用账号的具体规则，请遵守相关账号使用协议以及小黄人科技为此发布的专项规则。</p>
        <p class="p2" style="margin-left: 32px">6.1.2灵猴账号的所有权归小黄人科技公司所有，用户完成申请注册手续后，仅获得灵猴账号的使用权，且该使用权仅属于初始申请注册人。同时，初始申请注册人不得赠与、借用、租用、转让或售卖灵猴账号或者以其他方式许可非初始申请注册人使用灵猴账号。非初始申请注册人不得通过受赠、继承、承租、受让或者其他任何方式使用灵猴账号。</p>
        <p class="p2" style="margin-left: 32px;">6.1.3用户有责任妥善保管注册账户信息及账户密码的安全，用户需要对注册账户以及密码下的行为承担法律责任。用户同意在任何情况下不向他人透露账户及密码信息。当您怀疑他人在使用您的账号时，您应立即通知北京小黄人科技有限公司。</p>
        <p class="p2" style="margin-left: 32px;">6.1.4用户在使用手机号码注册灵猴账号时，系统将为您自动匹配灵猴号，您可以对灵猴号进行设置，但仅可设置一次，设置灵猴号后将无法修改。</p>
        <p class="p2" style="margin-left: 32px;">6.1.5用户注册灵猴账号后如果长期不登录该账号，小黄人科技有权回收该账号，以免造成资源浪费，由此带来的任何损失均由用户自行承担。</p>
        <p class="p2">6.2 用户注意事项</p>
        <p class="p2" style="margin-left: 32px">6.2.1您理解并同意：为了向您提供有效的服务，本软件会利用您终端设备的处理器和带宽等资源。本软件使用过程中可能产生数据流量的费用，用户需自行向运营商了解相关资费信息，并自行承担相关费用。</p>
        <p class="p2" style="margin-left: 32px">6.2.2您理解并同意：本软件的某些功能可能会让第三方知晓用户的信息，例如：用户的灵猴好友可以查询用户头像、名字、灵猴号或朋友圈内容等可公开的个人资料；使用手机号码注册灵猴账号或手机号码与灵猴账号关联的用户，灵猴账号可以被通讯录存有该号码的好友查询；用户关注部分类型灵猴公众账号后将成为公众账号关注用户，相关公众账号可以根据其功能权限获取关注用户头像、名字、灵猴号、消息评论内容、图片、视频等信息，并可通过灵猴公众平台发送消息与关注用户进行互动。关注用户的消息评论内容、向相关公众账号上传的图片、视频都可以被具备相应功能权限的灵猴公众账号发布在公众账号内，供第三方查阅。用户选择灵猴与其他软件或硬件信息互通后，其他软件或硬件的提供方可以获取用户在灵猴主动公开或传输的相关信息，用户在选择前应充分了解其他软件或硬件的产品功能及信息保护策略。</p>
        <p class="p2" style="margin-left: 32px">6.2.3您在使用本软件某一特定服务时，该服务可能会另有单独的协议、相关业务规则等（以下统称为“单独协议”），您在使用该项服务前请阅读并同意相关的单独协议；您使用前述特定服务，即视为您接受相关单独协议。</p>
        <p class="p2" style="margin-left: 32px">6.2.4您理解并同意小黄人科技将会尽其商业上的合理努力保障您在本软件及服务中的数据存储安全，但是，小黄人科技并不能就此提供完全保证，包括但不限于以下情形：</p>
        <p class="p2" style="margin-left: 52px">6.2.4.1小黄人科技不对您在本软件及服务中相关数据的删除或储存失败负责；</p>
        <p class="p2" style="margin-left: 52px">6.2.4.2小黄人科技有权根据实际情况自行决定单个用户在本软件及服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。您可根据自己的需要自行备份本软件及服务中的相关数据；</p>
        <p class="p2" style="margin-left: 52px">6.2.4.3如果您停止使用本软件及服务或服务被终止或取消，小黄人科技可以从服务器上永久地删除您的数据。服务停止、终止或取消后，小黄人科技没有义务向您返还任何数据。</p>
        <p class="p2" style="margin-left: 32px">6.2.5用户在使用本软件及服务时，须自行承担如下来自小黄人科技不可掌控的风险内容，包括但不限于：</p>
        <p class="p2" style="margin-left: 52px">6.2.5.1由于不可抗拒因素可能引起的个人信息丢失、泄漏等风险；</p>
        <p class="p2" style="margin-left: 52px">6.2.5.2用户必须选择与所安装终端设备相匹配的软件版本，否则，由于软件与终端设备型号不相匹配所导致的任何问题或损害，均由用户自行承担；</p>
        <p class="p2" style="margin-left: 52px">6.2.5.3用户在使用本软件访问第三方网站时，因第三方网站及相关内容所可能导致的风险，由用户自行承担；</p>
        <p class="p2" style="margin-left: 52px">6.2.5.4用户发布的内容被他人转发、分享，因此等传播可能带来的风险和责任；</p>
        <p class="p2" style="margin-left: 52px">6.2.5.5由于无线网络信号不稳定、无线网络带宽小等原因，所引起的小黄人科技灵猴登录失败、资料同步不完整、页面打开速度慢等风险。</p>
        <p class="p2">6.3 第三方产品和服务</p>
        <p class="p2" style="margin-left: 32px">6.3.1您在使用本软件第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。小黄人科技和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。</p>
        <p class="p2" style="margin-left: 32px">6.3.2因用户使用本软件或要求小黄人科技提供特定服务时，本软件可能会调用第三方系统或者通过第三方支持用户的使用或访问，使用或访问的结果由该第三方提供（包括但不限于第三方通过开放平台接入的内容等），小黄人科技不保证通过第三方提供服务及内容的安全性、准确性、有效性及其他不确定的风险，由此若引发的任何争议及损害，与小黄人科技无关，小黄人科技不承担任何责任。</p>
        <p class="p2" style="margin-left: 32px">6.3.3第三方服务提供者可以通过本软件向您提供产品或者服务。在此过程中，第三方服务提供者可能会收集、使用和存储您的相关数据或信息，小黄人科技通过与第三方服务提供者签署的有关协议、灵猴相关规范以及合理的产品流程设计，严格要求第三方服务提供者获取您的任何数据均应遵守相关法律法规的规定，必须事先获得你的明确同意，采取必要的数据保护措施，且仅为产品或服务之目的合理使用您的相关数据，向您提供修改或删除自己数据的方式，并在停止服务时必须删除全部数据等，尽最大可能保障您的数据和隐私不受侵害。您在接受或使用第三方产品或服务前应充分了解第三方产品或服务的条款及政策。如果您发现有第三方服务提供者存有相关违法违规行为，可以向小黄人科技投诉，小黄人科技将查实后予以处理。</p>
        <p class="p2" style="margin-left: 32px">6.3.4您理解并同意，小黄人科技有权决定将本软件作商业用途，包括但不限于开发、使用本软件的部分服务为第三方作推广等，小黄人科技承诺在推广过程中严格按照本协议约定保护您的个人信息，同时您也可以根据系统设置选择屏蔽、拒绝接收相关推广信息。</p>
      </div>
      <div class="model">
        <p class="p1">七 用户行为规范</p>
        <p class="p2">7.1 信息内容规范</p>
        <p class="p2" style="margin-left: 32px">7.1.1本条所述信息内容是指用户使用本软件及服务过程中所制作、复制、发布、传播的任何内容，包括但不限于灵猴账号头像、名字、用户说明等注册信息，或文字、语音、图片等发送、回复、朋友圈图文和相关链接页面，以及其他使用灵猴账号或本软件及服务所产生的内容。</p>
        <p class="p2" style="margin-left: 32px">7.1.2您理解并同意，灵猴一直致力于为用户提供文明健康、规范有序的网络环境，您不得利用灵猴账号或本软件及服务制作、复制、发布、传播如下干扰灵猴正常运营，以及侵犯其他用户或第三方合法权益的内容，包括但不限于：</p>
        <p class="p2" style="margin-left: 52px">7.1.2.1发布、传送、传播、储存违反国家法律法规禁止的内容：</p>
        <p class="p2" style="margin-left: 54px">（1）违反宪法确定的基本原则的；</p>
        <p class="p2" style="margin-left: 54px">（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
        <p class="p2" style="margin-left: 54px">（3）损害国家荣誉和利益的；</p>
        <p class="p2" style="margin-left: 54px">（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
        <p class="p2" style="margin-left: 54px">（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
        <p class="p2" style="margin-left: 54px">（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
        <p class="p2" style="margin-left: 54px">（7）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>
        <p class="p2" style="margin-left: 54px">（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
        <p class="p2" style="margin-left: 54px">（9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；</p>
        <p class="p2" style="margin-left: 54px">（10）以非法民间组织名义活动的；</p>
        <p class="p2" style="margin-left: 54px">（11）不符合《即时通信工具公众信息服务发展管理暂行规定》及遵守法律法规、社会主义制度、国家利益、公民合法利益、公共秩序、社会道德风尚和信息真实性等“七条底线”要求的；</p>
        <p class="p2" style="margin-left: 54px">（12）含有法律、行政法规禁止的其他内容的。</p>
        <p class="p2" style="margin-left: 52px">7.1.2.2发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</p>
        <p class="p2" style="margin-left: 52px">7.1.2.3涉及他人隐私、个人信息或资料的；</p>
        <p class="p2" style="margin-left: 52px">7.1.2.4发表、传送、传播骚扰、广告信息、过度营销信息及垃圾信息或含有任何性或性暗示的；</p>
        <p class="p2" style="margin-left: 52px">7.1.2.5其他违反法律法规、政策及公序良俗、社会公德或干扰灵猴正常运营和侵犯其他用户或第三方合法权益内容的信息。</p>
        <p class="p2">7.2 软件使用规范</p>
        <p class="p2" style="margin-left: 32px">7.2.1除非法律允许或小黄人科技书面许可，您使用本软件过程中不得从事下列行为：</p>
        <p class="p2" style="margin-left: 52px">7.2.1.1删除本软件及其副本上关于著作权的信息；</p>
        <p class="p2" style="margin-left: 52px">7.2.1.2对本软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本软件的源代码；</p>
        <p class="p2" style="margin-left: 52px">7.2.1.3对小黄人科技拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</p>
        <p class="p2" style="margin-left: 52px">7.2.1.4对本软件或者本软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及本软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非小黄人科技经授权的第三方工具/服务接入本软件和相关系统；</p>
        <p class="p2" style="margin-left: 52px">7.2.1.5通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</p>
        <p class="p2" style="margin-left: 52px">7.2.1.6通过非小黄人科技开发、授权的第三方软件、插件、外挂、系统，登录或使用小黄人科技软件及服务，或制作、发布、传播上述工具；</p>
        <p class="p2" style="margin-left: 52px">7.2.1.7自行或者授权他人、第三方软件对本软件及其组件、模块、数据进行干扰；</p>
        <p class="p2" style="margin-left: 52px">7.2.1.8其他未经小黄人科技明示授权的行为。</p>
        <p class="p2" style="margin-left: 32px">7.2.2您理解并同意，基于用户体验、灵猴或相关服务平台运营安全、平台规则要求及健康发展等综合因素，小黄人科技有权选择提供服务的对象，有权决定功能设置，有权决定功能开放、数据接口和相关数据披露的对象和范围。针对以下情形，有权视具体情况中止或终止提供本服务，包括但不限于：</p>
        <p class="p2" style="margin-left: 52px">7.2.2.1违反法律法规或本协议规定的；</p>
        <p class="p2" style="margin-left: 52px">7.2.2.2影响服务体验的；</p>
        <p class="p2" style="margin-left: 52px">7.2.2.3存在安全隐患的；</p>
        <p class="p2" style="margin-left: 52px">7.2.2.4与灵猴或其服务平台已有主要功能或功能组件相似、相同，或可实现上述功能或功能组件的主要效用的；</p>
        <p class="p2" style="margin-left: 52px">7.2.2.5界面、风格、功能、描述或使用者体验与灵猴或其服务平台类似，可能造成灵猴用户认为其所使用的功能或服务来源于小黄人科技或经小黄人科技授权的；</p>
        <p class="p2" style="margin-left: 52px">7.2.2.6违背灵猴或其服务平台运营原则，或不符合小黄人科技其他管理要求的。</p>
        <p class="p2">7.3服务运营规范</p>
        <p class="p2" style="margin-left: 32px">除非法律允许或小黄人科技书面许可，您使用本服务过程中不得从事下列行为：</p>
        <p class="p2" style="margin-left: 32px">7.3.1提交、发布虚假信息，或冒充、利用他人名义的；</p>
        <p class="p2" style="margin-left: 32px">7.3.2诱导其他用户点击链接页面或分享信息的；</p>
        <p class="p2" style="margin-left: 32px">7.3.3虚构事实、隐瞒真相以误导、欺骗他人的；</p>
        <p class="p2" style="margin-left: 32px">7.3.4侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；</p>
        <p class="p2" style="margin-left: 32px">7.3.5未经小黄人科技书面许可利用灵猴账号和任何功能，以及第三方运营平台进行推广或互相推广的；</p>
        <p class="p2" style="margin-left: 32px">7.3.6利用灵猴账号或本软件及服务从事任何违法犯罪活动的；</p>
        <p class="p2" style="margin-left: 32px">7.3.7制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；</p>
        <p class="p2" style="margin-left: 32px">7.3.8其他违反法律法规规定、侵犯其他用户合法权益、干扰产品正常运营或小黄人科技未明示授权的行为。</p>
        <p class="p2">7.4对自己行为负责</p>
        <p class="p2 in">您充分了解并同意，您必须为自己注册账号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。您应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。小黄人科技无法且不会对因前述风险而导致的任何损失或损害承担责任。</p>
        <p class="p2">7.5违约处理</p>
        <p class="p2" style="margin-left: 32px">7.5.1如果小黄人科技发现或收到他人举报或投诉用户违反本协议约定的，小黄人科技有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规账号处以包括但不限于警告、限制或禁止使用部分或全部功能、账号封禁直至注销的处罚，并公告处理结果。</p>
        <p class="p2" style="margin-left: 32px">7.5.2您理解并同意，小黄人科技有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应独自承担由此而产生的一切法律责任。</p>
        <p class="p2" style="margin-left: 32px">7.5.3您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；小黄人科技因此遭受损失的，您也应当一并赔偿。</p>
      </div>
      <div class="model">
        <p class="p1">八 知识产权声明</p>
        <p class="p2">8.1小黄人科技是本软件的知识产权权利人。本软件的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本软件相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受中华人民共和国法律法规和相应的国际条约保护，小黄人科技享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。</p>
        <p class="p2">8.2未经小黄人科技或相关权利人书面同意，您不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。</p>
        <p class="p2">8.3小黄人科技对用户在本服务提交的内容没有所有权，这些内容的所有权仍然归用户所有。但是，如果用户将页面设置为发布，就意味着用户允许其他人查看和共享用户的内容。</p>
        <p class="p2">8.4您应当了解，当您授权甲方共享您的作品内容时，甲方的其他注册用户可以二次编辑、传播、分享您通过小黄人科技编辑生成的共享作品。同时甲方有权再次编辑优化您的共享作品，以便为其他用户提供更好的内容服务。</p>
        <p class="p2">8.5您清楚并明白小黄人科技对用户提供的任何内容不在任何方面负有责任；除非小黄人科技事先收到相反通知，小黄人科技将用户视为在小黄人科技官网上传或发布的内容的著作权人或合法的被授权人。小黄人科技没有义务预先审查此类内容。但是，小黄人科技有权随时决定内容是否与本条款相符；如果发现此类内容违反本条款、在其他方面令人反感或违反相关法律法规等，小黄人科技可随时并有绝对酌情权进行核查、转移、拒绝、修改和/或删除内容，而不需事先通知。</p>
        <p class="p2">8.6甲方没有义务预先审查您发布的作品内容。但是，甲方有权随时决定查看作品内容是否与本协议相符；如果发现您的作品内容违反“灵猴”产品制作要求，甲方可随时并有绝对酌情权预先审查、转移、拒绝、修改和删除内容，而不需事先通知。</p>
        <p class="p2">8.7如您制作的内容脱离甲方服务器进入第三方服务，属于您的个体行为，甲方没有义务承担由于您的行为操作的任何后果。</p>
        <p class="p2">8.8如您在“灵猴”发布的作品内容，在本网站的上传或发布而导致任何第三方提出索赔要求或衍生的任何损害或损失，您承担赔偿甲方及其分公司、关联公司、代理人或其他合作伙伴及员工的全部责任，并使其免受损害。</p>
        <p class="p2">8.9如用户因购买了第三方所制作的侵犯了他人知识产权，或者违反法律法规的作品而被追究，用户可以向相应作品的第三方作者追究责任和索赔，小黄人科技不承担任何法律责任。</p>
      </div>
      <div class="model">
        <p class="p1">九终端安全责任</p>
        <p class="p2">9.1您理解并同意，本软件同大多数互联网软件一样，可能会受多种因素影响，包括但不限于用户原因、网络服务质量、社会环境等；也可能会受各种安全问题的侵扰，包括但不限于他人非法利用用户资料，进行现实中的骚扰；用户下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁您的终端设备信息和数据安全，继而影响本软件的正常使用等。因此，您应加强信息安全及个人信息的保护意识，注意密码保护，以免遭受损失。</p>
        <p class="p2">9.2您不得制作、发布、使用、传播用于窃取灵猴账号及他人个人信息、财产的恶意程序。</p>
        <p class="p2">9.3维护软件安全与正常使用是小黄人科技和您的共同责任，小黄人科技将按照行业标准合理审慎地采取必要技术措施保护您的终端设备信息和数据安全，但是您承认和同意小黄人科技并不能就此提供完全保证。</p>
        <p class="p2">9.4在任何情况下，您不应轻信借款、索要密码或其他涉及财产的网络信息。涉及财产操作的，请一定先核实对方身份，并请经常留意小黄人科技有关防范诈骗犯罪的提示。</p>
      </div>
      <div class="model">
        <p class="p1">十第三方软件或技术</p>
        <p class="p2">10.1本软件可能会使用第三方软件或技术（包括本软件可能使用的开源代码和公共领域代码等，下同），这种使用已经获得合法授权。</p>
        <p class="p2">10.2本软件如果使用了第三方的软件或技术，小黄人科技将按照相关法规或约定，对相关的协议或其他文件，可能通过本协议附件、在本软件安装包特定文件夹中打包、或通过开源软件页面等形式进行展示，它们可能会以“软件使用许可协议”、“授权协议”、“开源代码许可证”或其他形式来表达。前述通过各种形式展现的相关协议、其他文件及网页，均是本协议不可分割的组成部分，与本协议具有同等的法律效力，您应当遵守这些要求。如果您没有遵守这些要求，该第三方或者国家机关可能会对你提起诉讼、罚款或采取其他制裁措施，并要求小黄人科技给予协助，您应当自行承担法律责任。</p>
        <p class="p2">10.3如因本软件使用的第三方软件或技术引发的任何纠纷，应由该第三方负责解决，小黄人科技不承担任何责任。小黄人科技不对第三方软件或技术提供客服支持，若您需要获取支持，请与第三方联系。</p>
      </div>
      <div class="model">
        <p class="p1">十一其他</p>
        <p class="p2">11.1您使用本软件即视为您已阅读并同意受本协议的约束。小黄人科技有权在必要时修改本协议条款。您可以在本软件的最新版本中查阅相关协议条款。本协议条款变更后，如果您继续使用本软件，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本软件。</p>
        <p class="p2">11.2本协议签订地为中华人民共和国北京市西城区。</p>
        <p class="p2">11.3本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</p>
        <p class="p2">11.4若您和小黄人科技之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。</p>
        <p class="p2">11.5本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</p>
        <p class="p2">11.6本协议可能存在包括中文、英文在内的多种语言的版本，如果存在中文版本与其他语言的版本相冲突的地方，以中文版本为准。</p>
        <p class="p2">11.7本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>
      </div>
      <div class="model">
        <p class="p1">（正文完）</p>
      </div>
      <div class="model">
        <p class="p1" style="text-align: right;">北京小黄人科技有限公司</p>
      </div>
  </div>
    <div class="right-bottom">
      <ul>
        <!-- <li class="pop"> -->
          <!-- <a href="javascript:;"> -->
            <!-- <p>问<br>题<br>反<br>馈</p> -->
          <!-- </a> -->
          <!--<div class="out-div">-->
          <!--<div class="arrow" ></div>-->
          <!--<div class="make-complaints">对我们吐个槽吧</div>-->
          <!--</div>-->
        <!-- </li> -->
        <li>
          <p>联<br>系<br>客<br>服</p>
          <div class="to-manage">
            <div class="arrow else-arrow"></div>
            <img src="../assets/image/ask.png" alt="" class="to-manage-img">
            <div class="to-manage-text">更多问题<br>扫码向哪吒提问</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'helpCenter',
  created () {
    window.scrollTo(0, 0)
  },
  mounted () {},
  methods: {}
}
</script>
<style scoped>
  .content-agreement {
    min-height: 800px;
    padding: 20px;
  }
  * {
    box-sizing: border-box;
  }
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  .clearFix:after {
    clear: both;
    content: '';
    display: block;
  }
  .clearFix {
    zoom: 1;
  }
  .content-agreement {
    width: 1200px;
    background: #ffffff;
    margin: 20px auto;
  }
  .nav-help {
    cursor: pointer;
    width: 170px;
    border-left: 1px solid #f7f8fa;
  }
  .one-text {
    height: 46px;
    line-height: 46px;
    font-size: 16px;
    color: #525559;
    padding-left: 20px;
    border-bottom: 1px solid #f7f8fa;
    position: relative;
  }
  .one-text.active:after {
    background-position: -6px -159px;
  }
  .one-text:after {
    content: '';
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    width: 14px;
    height: 10px;
    background: url("../../static/image/icon.png") no-repeat -6px -110px;
  }
  .one-text.active:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    border-left: 4px solid #2a75ed;
  }
  .tow-text {
    padding-left: 20px;
    font-size: 14px;
    color: #525559;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #f7f8fa;
  }
  .tow-text.active {
    background: #3180ef;
    color: #ffffff;
  }
  .help-content {
    width: 609px;
    background: #ffffff;
    padding-left: 19px;
    padding-right: 19px;
    border-left: 1px solid #f7f8fa;
    border-right: 1px solid #f7f8fa;
  }
  .content-right {
    width: calc(100% - 170px - 609px);
    padding-left: 20px;
    padding-top: 32px;
    padding-right: 20px;
  }
  .content-right-title {
    font-size: 16px;
    color: #337bee;
  }
  .content-right ul {
    margin-top: 30px;
  }
  .content-right ul li {
    line-height: 34px;
    font-size: 14px;
    color: #65696d;
  }
  .content-right ul li p {
    cursor: pointer;
  }
  .list-hide {
    line-height: 20px;
    color: #ffffff;
    padding: 10px 15px;
    background: #6ea6f3;
  }
  .list-hide img {
    width: 100%;
  }
  .right-bottom {
    position: fixed;
    right: -5px;
    top: 300px;
    z-index: 1000;
  }
  .right-bottom ul {
    list-style: none;
  }
  .right-bottom ul li {
    width: 40px;
    height: 100px;
    margin-top: 13px;
    text-align: center;
    cursor: pointer;
    position: relative;
  }
  .right-bottom ul li p {
    background: #5497fd;
    width: 34px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px 0 0 4px;
    padding: 0;
    color: #ffffff;
  }
  .right-bottom ul li:hover .out-div {
    display: block;
  }
  .right-bottom ul .pop:hover p {
    width: 44px;
    position: absolute;
    left: -10px;
    height: 100px;
    padding: 0;
    box-shadow: 0 0 15px rgba(84, 151, 253, 0.6);
  }
  .right-bottom ul li:hover .to-manage {
    display: block;
  }
  .right-bottom ul li {
    line-height: initial;
    color: #ffffff;
    font-size: 14px;
  }
  .make-complaints {
    position: absolute;
    right: -148px;
    width: 138px;
    height: 33px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    color: #ffffff;
    line-height: 33px;
    display: none;
    background: url("../../static/image/icon.png") -7px -405px no-repeat;
  }
  .to-manage {
    display: none;
    width: 129px;
    height: 175px;
    background-color: #3180ef;
    background: url("../../static/image/icon.png") -7px -200px no-repeat;
    position: absolute;
    right: 64px;
    bottom: 0;
    padding-top: 7px;
    border-radius: 4px;
    z-index: 1000;
  }
  .to-manage-img {
    width: 108px;
    height: 108px;
    margin: 0 auto;
    display: block;
  }
  .to-manage-text {
    padding-top: 5px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    line-height: 20px;
  }
  .out-div {
    position: absolute;
    right: 55px;
    width: 138px;
    height: 33px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    color: #fff;
    line-height: 33px;
    display: none;
    background: #4d4d4d;
    border-radius: 4px;
    z-index: 1000;
  }
  .model {
    margin-top: 60px;
  }
  .p1 {
    font-size: 16px;
    line-height: 32px;
    color: #333;
  }
  .p2 {
    font-size: 14px;
    line-height: 28px;
    color: #444;
  }
  .in {
    text-indent: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/components/linghouAgreement.vue